module.exports = __webpack_public_path__ + "media/video-y-fotografia-aerea_reel.9eda2762.webm";